import customer from '@/backend/services/account/customer';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
const chat = {
	state: {
		webList: [],
		activeWebsite: {},
		activeWebsiteId: null
	},
	mutations: {
		SET_WEDLIST: (state, value) => {
			state.webList = value;
		},
		SET_ACTIVEWEBSITE: (state, value) => {
			state.activeWebsite = value;
		},
		SET_ACTIVEWEBSITEID: (state, value) => {
			state.activeWebsiteId = value;
		},
	},
	actions: {
		async getWeblist({ commit }, value) {
			try {
				let res = await getWebsiteByCustomer({ customerId: value });
				if (res.data && res.data.length) {
					sessionStorage.setItem('activeWebsiteId', res.data[0].id);
					commit('SET_ACTIVEWEBSITEID', res.data[0].id)
					commit('SET_ACTIVEWEBSITE', res.data[0]);
					commit('SET_WEDLIST', res.data);
				}
				return Promise.resolve(res);
			} catch (e) {
				return Promise.reject(e);
			}
		},
	},
};

export default chat;
